import React from 'react';

const Footer = () => {
  const links = ['Contacto', 'Términos', 'Privacidad'];

  return (
    <footer
      data-testid="footer"
      style={{
        background: '#0A0A0A',
        borderTop: 'none',
        padding: '64px 24px',
        textAlign: 'center',
      }}
    >
      <div style={{
        fontFamily: 'Inter, sans-serif',
        fontWeight: 200,
        fontSize: '14px',
        letterSpacing: '0.3em',
        color: '#FFFFFF',
        marginBottom: '32px',
      }}>
        ETERNA WATER
      </div>

      <div style={{
        display: 'flex',
        justifyContent: 'center',
        gap: '32px',
        flexWrap: 'wrap',
        marginBottom: '24px',
      }}>
        {links.map(link => (
          <a
            key={link}
            href={`#${link.toLowerCase()}`}
            style={{
              fontFamily: 'Inter, sans-serif',
              fontWeight: 300,
              fontSize: '13px',
              letterSpacing: '0.06em',
              color: '#6B6B6B',
              textDecoration: 'none',
              transition: 'color 250ms ease',
            }}
            onMouseEnter={e => e.currentTarget.style.color = '#FFFFFF'}
            onMouseLeave={e => e.currentTarget.style.color = '#6B6B6B'}
            data-testid={`footer-link-${link.toLowerCase()}`}
          >
            {link}
          </a>
        ))}
      </div>

      <div style={{
        fontFamily: 'Inter, sans-serif',
        fontWeight: 200,
        fontSize: '12px',
        color: '#6B6B6B',
        marginBottom: '16px',
      }}>
        © 2026 ETERNA WATER. Todos los derechos reservados.
      </div>

      <div style={{
        fontFamily: 'Inter, sans-serif',
        fontWeight: 200,
        fontSize: '14px',
        letterSpacing: '0.12em',
        color: '#FFFFFF',
        marginTop: '16px',
      }}>
        Pureza que inspira.
      </div>
    </footer>
  );
};

export default Footer;
